import { RootState } from 'redhotpie-shared-lib/hooks/useRedux';
import { REFINE_MODAL } from '../constants/constants';

export const getUserInfo = (state: RootState) => state.loginReducer.userInfo;
export const getUserInfoImmutable = (state: RootState) => state.loginReducer.userInfo;
export const getToolTips = (state: RootState) => state.loginReducer.userInfo.toolTips;
export const getLocationInfo = (state: RootState) => state.loginReducer.userInfo?.locationInfo;
export const getMessengerSetting = (state: RootState) => state.loginReducer.userInfo.messenger;
export const getMessengerSettingLoading = (state: RootState) => state.loginReducer.userInfo?.messenger?.isLoading;
export const getDefaultFolder = (state: RootState) => state.loginReducer.userInfo?.messenger?.defaultFolder;
export const getIsPlaySound = (state: RootState) => state.loginReducer.userInfo?.chatroomSettings?.isSoundEnabled;
export const getRHPUserName = (state: RootState) => state.loginReducer.rhpUserName;
export const getRHPPassword = (state: RootState) => state.loginReducer.rhpPassword;
export const getChatUserName = (state: RootState) => state.loginReducer.userName;
export const getChatPassword = (state: RootState) => state.loginReducer.password;
export const getIsLogin = (state: RootState) => state.loginReducer.isLogin;
export const getIsLogOut = (state: RootState) => state.loginReducer.isLoginOut;
export const getIsLoginFB = (state: RootState) => state.loginReducer.isLoginFb;
export const selectReconnecting = (state: RootState) => state.loginReducer.reconnecting;
export const selectLoginUserId = (state: RootState) => state.loginReducer.userInfo?.userId;
export const selectIsOutSideAU = (state: RootState) =>
  state.loginReducer.userInfo?.country?.name !== REFINE_MODAL.LOCATION_DEFAULT || false;
export const getError = (state: RootState) => state.loginReducer.error;
export const getMsg = (state: RootState) => state.loginReducer.msg;
export const selectPhoneNumberCountryCode = (state: RootState) => state.loginReducer.phoneNumberCountryCode;
export const selectIsOpenWS = (state: RootState) => state.loginReducer.isOpenWS;
export const selectUserStatus = (state: RootState) => state.loginReducer.userStatus;
export const selectTimestampUpdate = (state: RootState) => state.loginReducer.timestampUpdate;
export const selectIsLoginXmpp = (state: RootState) => state.loginReducer.isLoginXmpp;
export const selectGettingUserXmppDetail = (state: RootState) => state.loginReducer.gettingUserXmppDetail;
export const selectProfileBoostExpiry = (state: RootState) => state.loginReducer.userInfo?.profileBoostExpiry || 0;
export const selectIsStreaming = (state: RootState) => state.loginReducer.isStreaming;
